import { createContext } from 'react';
import { FormProvider } from "../enums";
export default /*#__PURE__*/createContext({
  provider: FormProvider.Final
});